module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/static-modal-app/img/layer-4@3x__c2c2711c3dc311fc2ea875d8f8dcc493.png";